import { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const products = [
  { label: "e智图", path: "/products/ezt-map", icon: "ri-map-line" },
  { label: "营销市场洞察", path: "/products/enterprise-insight", icon: "ri-bar-chart-box-line" },
  { label: "商业选址分析", path: "/products/business-analytics", icon: "ri-pie-chart-2-line" },
  { label: "政务网格管理", path: "/products/gov-grid", icon: "ri-government-line" },
];

const staticNavItems = [
  { label: "API服务", path: "/api-service" },
  { label: "数据开放平台", path: "/api-pingtai" },
  { label: "移动端", path: "/mobile" },
  { label: "个人数据空间", path: "/personal-space" },
  // { label: "e智图", path: "/ezt-map" },
];

export default function TopNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [productOpen, setProductOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const productRef = useRef<HTMLDivElement>(null);
  const userRef = useRef<HTMLDivElement>(null);

  const isHome = location.pathname === "/";
  const isProductActive = products.some((p) => location.pathname.startsWith("/products"));

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (productRef.current && !productRef.current.contains(e.target as Node)) {
        setProductOpen(false);
      }
      if (userRef.current && !userRef.current.contains(e.target as Node)) {
        setUserOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 h-14"
      style={{ background: "linear-gradient(90deg, #1e3d7a 0%, #2550a0 60%, #1e3d7a 100%)" }}
    >
      {/* Logo */}
      <div
        className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
        onClick={() => navigate("/")}
      >
        <div className="w-7 h-7 flex items-center justify-center">
          <i className="ri-earth-fill text-cyan-300 text-xl"></i>
        </div>
        <span className="text-white font-bold text-base tracking-wide">空天·数源</span>
      </div>

      {/* Nav */}
      <nav className="flex items-center gap-8">
        {/* 首页 */}
        <button
          onClick={() => navigate("/")}
          className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap pb-0.5 ${
            isHome ? "text-white border-b-2 border-cyan-300" : "text-blue-100/80 hover:text-white"
          }`}
        >
          首页
        </button>

        {/* 产品服务下拉 */}
        <div ref={productRef} className="relative">
          <button
            onClick={() => setProductOpen(!productOpen)}
            className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap pb-0.5 flex items-center gap-1 ${
              isProductActive
                ? "text-white border-b-2 border-cyan-300"
                : "text-blue-100/80 hover:text-white"
            }`}
          >
            产品服务
            <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${productOpen ? "rotate-180" : ""}`}></i>
          </button>

          {productOpen && (
            <div className="absolute top-10 left-1/2 -translate-x-1/2 w-52 bg-white rounded-xl overflow-hidden border border-slate-100"
              style={{ boxShadow: "0 8px 32px rgba(30,61,122,0.18)" }}>
              {/* 小三角 */}
              <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-4 h-2 overflow-hidden">
                <div className="w-3 h-3 bg-white border-l border-t border-slate-100 rotate-45 translate-y-1.5 mx-auto"></div>
              </div>
              <div className="pt-1 pb-1">
                {products.map((p) => (
                  <button
                    key={p.path}
                    onClick={() => { navigate(p.path); setProductOpen(false); }}
                    className={`w-full flex items-center gap-3 px-4 py-3 text-sm transition-colors cursor-pointer whitespace-nowrap group ${
                      location.pathname === p.path
                        ? "bg-blue-50 text-blue-700 font-semibold"
                        : "text-slate-700 hover:bg-slate-50 hover:text-blue-700"
                    }`}
                  >
                    <span className={`w-7 h-7 flex items-center justify-center rounded-lg text-base flex-shrink-0 transition-colors ${
                      location.pathname === p.path
                        ? "bg-blue-100 text-blue-600"
                        : "bg-slate-100 text-slate-500 group-hover:bg-blue-50 group-hover:text-blue-500"
                    }`}>
                      <i className={p.icon}></i>
                    </span>
                    <span>{p.label}</span>
                    {location.pathname === p.path && (
                      <i className="ri-check-line ml-auto text-blue-500 text-sm"></i>
                    )}
                  </button>
                ))}
              </div>
              <div className="border-t border-slate-100 px-4 py-2.5">
                <span className="text-xs text-slate-400">选择产品进入详细功能</span>
              </div>
            </div>
          )}
        </div>

        {/* 其他导航项 */}
        {staticNavItems.map((item) => (
          <button
            key={item.label}
            onClick={() => navigate(item.path)}
            className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap pb-0.5 ${
              location.pathname === item.path
                ? "text-white border-b-2 border-cyan-300"
                : "text-blue-100/80 hover:text-white"
            }`}
          >
            {item.label}
          </button>
        ))}
      </nav>

      {/* User */}
      <div className="relative" ref={userRef}>
        <button
          onClick={() => setUserOpen(!userOpen)}
          className="w-9 h-9 rounded-full border border-blue-300/40 flex items-center justify-center text-blue-100 hover:text-white hover:border-blue-200 transition-colors cursor-pointer"
        >
          <i className="ri-user-line text-lg"></i>
        </button>
        {userOpen && (
          <div className="absolute right-0 top-11 w-36 bg-white border border-slate-200 rounded-lg overflow-hidden"
            style={{ boxShadow: "0 8px 24px rgba(30,61,122,0.12)" }}>
            {["个人中心", "我的数据", "设置", "退出登录"].map((opt) => (
              <button
                key={opt}
                className="w-full text-left px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                {opt}
              </button>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
